// @ts-nocheck
(() => {
  function initQuoteCarousel(stage) {
    const track = stage.querySelector('[data-hc-track]');
    const cards = Array.from(stage.querySelectorAll('[data-hc-card]'));
    if (!track || cards.length < 2) return;

    const AUTOPLAY_MS = parseInt(stage.dataset.autoplay, 10) || 4000;
    const N = cards.length;
    const CARD_W = 380;
    const GAP = 32;
    const STEP = CARD_W + GAP;
    const LERP = 0.08;

    // Triple cards for infinite loop
    track.innerHTML = '';
    [...cards, ...cards, ...cards].forEach(c => track.appendChild(c.cloneNode(true)));
    const trackCards = Array.from(track.querySelectorAll('[data-hc-card]'));

    // State
    let targetIdx = N;        // card index we're animating toward (middle copy = [N, 2N-1])
    let currentX = -N * STEP; // actual rendered pixel offset
    let lastCenterIdx = -1;
    let rafId = 0;
    let autoTimer = 0;
    let paused = false;
    let dragging = false;
    let dragStartClientX = 0;
    let dragStartCurrentX = 0;

    function applyTransform(x) {
      track.style.transform = `translateX(calc(50% - ${CARD_W / 2}px + ${x}px))`;
    }

    function setActiveCard(idx) {
      if (idx === lastCenterIdx) return;
      lastCenterIdx = idx;
      // Pre-activate the wrapped mirror so both clones are in sync when the position jumps
      const mirrorIdx = idx >= 2 * N ? idx - N : (idx < N ? idx + N : -1);
      trackCards.forEach((card, i) => card.toggleAttribute('data-center', i === idx || i === mirrorIdx));
    }

    function tick() {
      if (dragging) {
        // During drag currentX is written directly by onDragMove — just render it
        applyTransform(currentX);
      } else {
        const targetX = -targetIdx * STEP;
        const diff = targetX - currentX;

        if (Math.abs(diff) < 0.5) {
          currentX = targetX;
          // Wrap seamlessly: same visual position, different clone — no jump possible
          while (targetIdx >= 2 * N) { targetIdx -= N; currentX += N * STEP; }
          while (targetIdx < N)       { targetIdx += N; currentX -= N * STEP; }
        } else {
          currentX += diff * LERP;
        }

        applyTransform(currentX);
        setActiveCard(targetIdx);
      }

      rafId = requestAnimationFrame(tick);
    }

    function advance(delta = 1) {
      targetIdx += delta;
      setActiveCard(targetIdx);
    }

    function scheduleAutoplay() {
      clearTimeout(autoTimer);
      if (!paused) {
        autoTimer = setTimeout(() => {
          advance(1);
          scheduleAutoplay();
        }, AUTOPLAY_MS);
      }
    }

    // ─── Hover pause ────────────────────────────────────────────────────────────

    stage.addEventListener('mouseenter', () => {
      paused = true;
      clearTimeout(autoTimer);
    });

    stage.addEventListener('mouseleave', (_e) => {
      if (dragging) onDragEnd(_e);
      paused = false;
      scheduleAutoplay();
    });

    // ─── Drag ────────────────────────────────────────────────────────────────────

    function onDragStart(e) {
      dragging = true;
      dragStartClientX = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
      dragStartCurrentX = currentX;
      paused = true;
      clearTimeout(autoTimer);
      stage.classList.add('is-dragging');
    }

    function onDragMove(e) {
      if (!dragging) return;
      const x = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
      currentX = dragStartCurrentX + (x - dragStartClientX);
      // Show which card the drag position is closest to
      const nearest = Math.round(-currentX / STEP);
      setActiveCard(Math.max(0, Math.min(3 * N - 1, nearest)));
    }

    function onDragEnd(e) {
      if (!dragging) return;
      dragging = false;
      stage.classList.remove('is-dragging');
      // Snap targetIdx to nearest card and let rAF lerp to it
      targetIdx = Math.round(-currentX / STEP);
      targetIdx = Math.max(0, Math.min(3 * N - 1, targetIdx));
      setActiveCard(targetIdx);
      setTimeout(() => { paused = false; scheduleAutoplay(); }, 600);
    }

    stage.addEventListener('mousedown', onDragStart);
    stage.addEventListener('mousemove', onDragMove);
    stage.addEventListener('mouseup', onDragEnd);
    stage.addEventListener('touchstart', onDragStart, { passive: true });
    stage.addEventListener('touchmove', onDragMove, { passive: true });
    stage.addEventListener('touchend', onDragEnd);

    // ─── Init ────────────────────────────────────────────────────────────────────

    applyTransform(currentX);
    setActiveCard(targetIdx);
    rafId = requestAnimationFrame(tick);
    scheduleAutoplay();

    stage.closest('[id]')?.addEventListener('shopify:section:unload', () => {
      cancelAnimationFrame(rafId);
      clearTimeout(autoTimer);
    });
  }

  document.querySelectorAll('[data-hc-quote-carousel]').forEach(initQuoteCarousel);

  document.addEventListener('shopify:section:load', (e) => {
    const stage = /** @type {Element} */ (e.target)?.querySelector('[data-hc-quote-carousel]');
    if (stage) initQuoteCarousel(stage);
  });
})();
